import { MenuItem, TextField, Tooltip, Typography } from '@mui/material'
import type { FieldProps } from '@rjsf/utils'
import { useTranslation } from 'react-i18next'
import { makeStyles } from 'tss-react/mui'
import { CorrosionMap } from './CorrosionMap'

const useStyles = makeStyles({ name: 'CorrosionClassificationField' })(
  (theme) => ({
    tooltip: {
      maxWidth: 'none',
      backgroundColor: theme.palette.background.default,
      border: `1px solid ${theme.palette.divider}`,
    },
  }),
)

export function CorrosionClassificationField(props: FieldProps<string>) {
  const { t } = useTranslation('project')
  const { classes } = useStyles()
  const { fieldPathId, formData, onChange } = props

  return (
    <div style={{ width: '100%', display: 'flex' }}>
      <Tooltip
        classes={{
          tooltip: classes.tooltip,
        }}
        title={
          <CorrosionMap
            onChange={(corrosionClassification) => {
              onChange(corrosionClassification, fieldPathId.path)
            }}
            value={formData}
          />
        }
        placement="auto"
      >
        <TextField
          select
          label={t(props.uiSchema['ui:label-translation-key'])}
          value={formData}
          onChange={(e) => onChange(e.target.value, fieldPathId.path)}
          fullWidth
          size="small"
          slotProps={{
            htmlInput: {
              sx: {
                padding: '1px 1em 2px 0',
              },
            },
          }}
        >
          {props.schema['x-enumNames'].map((option: string) => (
            <MenuItem key={option} value={option}>
              <Typography variant="body2">
                {t('project:corrosion-' + option, option)}
              </Typography>
            </MenuItem>
          ))}
        </TextField>
      </Tooltip>
    </div>
  )
}
